<template>
  <div class="step-brindes">
    <Brinde :item="item" />
  </div>
</template>

<script>
import Brinde from "../components/Brinde/Brinde.vue";

export default {
  name: "StepBrindes",
  components: { Brinde },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
